import axiosInstance from './axiosInstance';

export const getActiveBuddies = (userId) =>
    axiosInstance.get(`/UserBuddy/user/${userId}`).then(r => r.data);

export const getBuddyHistory = (userId) =>
    axiosInstance.get(`/UserBuddy/user/${userId}/history`).then(r => r.data);

export const getAllActiveBuddies = () =>
    axiosInstance.get('/UserBuddy/all-active').then(r => r.data);

export const saveBuddies = (body) =>
    axiosInstance.post('/UserBuddy/save', body).then(r => r.data);

// Does this upline (or anyone up its chain) already have a multi-buddy split?
// → { hasSplit: bool, blockedBy: string }. Used to grey out "Add Buddy" for a
// downline of a buddy (nested splits aren't allowed).
export const chainHasBuddySplit = (uplineUserId) =>
    axiosInstance.get(`/UserBuddy/chain-has-split/${uplineUserId}`).then(r => r.data);
